import {AccountSummary} from '../../../../../../shared/model/account/accountSummary.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class UserAccountSummaryModel {
    account: AccountSummary;
    defaultAccount: boolean;
    role: LovValueSummary;
    active: boolean;

}

export enum PermissionScope {
    PUBLIC = 'PUBLIC',
    EXTERNAL_PARTNER = 'EXTERNAL_PARTNER',
    ACCOUNT = 'ACCOUNT',
}
